export default class ProdutoCreateProdutoController {
  constructor($q, $state, $scope, AuthenticationService, UIService, ProdutoService, Produto, ProdutoInvestigador, ProdutoEntidadeFinanciadora, ProdutoTipo, Investigador, EntidadeFinanciadora, Pais, Impacto, ImpactoOds, Ods) {
    this.$q = $q;
    this.state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.ProdutoService = ProdutoService;
    this.loaded = false;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.Produto = Produto;
    this.ProdutoInvestigador = ProdutoInvestigador;
    this.ProdutoEntidadeFinanciadora = ProdutoEntidadeFinanciadora;
    this.ProdutoTipo = ProdutoTipo;
    this.Investigador = Investigador;
    this.EntidadeFinanciadora = EntidadeFinanciadora;
    this.Pais = Pais;
    this.Impacto = Impacto;
    this.ImpactoOds = ImpactoOds;
    this.Ods = Ods;
    this.investigadores = null;
    this.produtosTipo = null;

    this.emptyData = {
      form: 1,
      details: {},
      impacto: {ods: []},

      investigadores: [],
      entidadesFinanciadoras: [],
      auxTipo: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxOpenAccess: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxRelatorioDisponivel: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxMadeAvailable: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},

      auxImpactoAmbiental: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxImpactoEconomico: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxImpactoSocial: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxImpactoPolicyInfluence: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}}
    };

    this.year = moment().format('YYYY');

    // Load data to fill ui-selects
    this.loadAuxData();

    $scope.$watch(() => {
      return this.data;
    }, (val) => {
      if (angular.isDefined(val)) {
        localStorage.setItem('ISR_SGI_ProdutoNewForm', JSON.stringify(val));
      }
    }, true);
  }

  loadAuxData = () => {
    this.ProdutoTipo.find({}).$promise.then((produtosTipo) => {
      this.produtosTipo = produtosTipo;
      this.Investigador.find({}).$promise.then((investigadores) => {
        investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
        this.investigadores = investigadores;
        this.loadDataFromStorage();
        this.loaded = true;
      }).catch(err => {
        console.log(err);
        this.UI.addToast("Erro ao carregar investigadores. Verifique a sua ligação");
        this.state.go('app.produto.list');
      });
    }).catch(err => {
      console.log(err);
      this.UI.addToast("Erro ao carregar tipos de produto. Verifique a sua ligação");
      this.state.go('app.produto.list');
    });
  };


  // Infinite Scroll magic
  addMoreItems = (infiniteScroll) => {
    infiniteScroll.currentItems += infiniteScroll.numToAdd;
  };

  loadDataFromStorage = () => {
    if (localStorage.getItem('ISR_SGI_ProdutoNewForm')) {
      let storageData = JSON.parse(localStorage.getItem('ISR_SGI_ProdutoNewForm'));
      // Only use what is required
      this.data = {};
      if (storageData.form) this.data.form = storageData.form; else this.data.form = angular.copy(this.emptyData.form);
      if (storageData.details) this.data.details = storageData.details; else this.data.details = angular.copy(this.emptyData.details);
      if (storageData.impacto) this.data.impacto = storageData.impacto; else this.data.impacto = angular.copy(this.emptyData.impacto);

      if (storageData.entidadesFinanciadoras) this.data.entidadesFinanciadoras = storageData.entidadesFinanciadoras; else this.data.entidadesFinanciadoras = angular.copy(this.emptyData.entidadesFinanciadoras);
      if (storageData.investigadores) this.data.investigadores = storageData.investigadores; else this.data.investigadores = angular.copy(this.emptyData.investigadores);

      if (storageData.auxTipo) this.data.auxTipo = storageData.auxTipo; else this.data.auxTipo = angular.copy(this.emptyData.auxTipo);
      if (storageData.auxOpenAccess) this.data.auxOpenAccess = storageData.auxOpenAccess; else this.data.auxOpenAccess = angular.copy(this.emptyData.auxOpenAccess);
      if (storageData.auxRelatorioDisponivel) this.data.auxRelatorioDisponivel = storageData.auxRelatorioDisponivel; else this.data.auxRelatorioDisponivel = angular.copy(this.emptyData.auxRelatorioDisponivel);
      if (storageData.auxMadeAvailable) this.data.auxMadeAvailable = storageData.auxMadeAvailable; else this.data.auxMadeAvailable = angular.copy(this.emptyData.auxMadeAvailable);

      if (storageData.auxImpactoAmbiental) this.data.auxImpactoAmbiental = storageData.auxImpactoAmbiental; else this.data.auxImpactoAmbiental = angular.copy(this.emptyData.auxImpactoAmbiental);
      if (storageData.auxImpactoEconomico) this.data.auxImpactoEconomico = storageData.auxImpactoEconomico; else this.data.auxImpactoEconomico = angular.copy(this.emptyData.auxImpactoEconomico);
      if (storageData.auxImpactoSocial) this.data.auxImpactoSocial = storageData.auxImpactoSocial; else this.data.auxImpactoSocial = angular.copy(this.emptyData.auxImpactoSocial);
      if (storageData.auxImpactoPolicyInfluence) this.data.auxImpactoPolicyInfluence = storageData.auxImpactoPolicyInfluence; else this.data.auxImpactoPolicyInfluence = angular.copy(this.emptyData.auxImpactoPolicyInfluence);
    } else {
      this.data = angular.copy(this.emptyData);
    }
    this.state.transitionTo('app.produto.new.' + this.data.form);
  };

  setForm = num => {
    this.data.form = num;
    this.state.transitionTo('app.produto.new.' + this.data.form);
  };

  cleanForm = () => {
    // Clean filled data
    this.data = angular.copy(this.emptyData);
    this.state.transitionTo('app.produto.new.' + this.data.form);
  };

  submit = () => {
    this.isValid().then(() => {
      this.loaded = false;
      // Create Produto and related data
      this.data.details.id = 0;
      this.data.details.produtoTipoId = this.data.auxTipo.selected.id;

      this.data.details.openAccess = this.data.auxOpenAccess.selected.value;
      this.data.details.relatorioDisponivel = this.data.auxRelatorioDisponivel.selected.value;
      this.data.details.madeAvailable = this.data.auxMadeAvailable.selected.value;

      this.data.details.criadoPorId = this.user.id;
      this.data.details.dataCriacao = moment().format();
      this.data.details.atualizadoPorId = this.user.id;
      this.data.details.atualizadoa = moment().format();

      this.Produto.create(this.data.details).$promise.then((produto) => {

        // Create all Entidades Financiadoras
        let deferEntidadesFinanciadoras = this.$q.defer();
        this.ProdutoService.createMultipleData(this.ProdutoEntidadeFinanciadora, this.data.entidadesFinanciadoras, produto.id, 'produtoId').then((x) => {
          deferEntidadesFinanciadoras.resolve({ok: true});
        }).catch(err => {
          deferEntidadesFinanciadoras.resolve({ok: false, output: 'Entidades Financiadoras'});
        });

        // Create all Investigadores (Co-Autores)
        let deferInvestigadores = this.$q.defer();
        this.ProdutoService.createMultipleData(this.ProdutoInvestigador, this.data.investigadores, produto.id, 'produtoId').then((x) => {
          deferInvestigadores.resolve({ok: true});
        }).catch(err => {
          deferInvestigadores.resolve({ok: false, output: 'Autores'});
        });

        // Save Impacto
        let deferImpacto = this.$q.defer();
        this.saveImpacto(this.data.impacto, produto, this.Produto).then(x => {
          deferImpacto.resolve({ok: true});
        }).catch(err => {
          deferImpacto.resolve(err); // Resolve data is solved inside since it's multi-answer
        });

        let promises = [deferEntidadesFinanciadoras.promise, deferInvestigadores.promise, deferImpacto.promise];

        // After all multiple data information is created/settled
        this.$q.all(promises).then((res) => {
          this.UI.addToast("Produto criado com sucesso");

          localStorage.removeItem('ISR_SGI_ProdutoNewForm');

          let error = this.createdMultipleDataOk(res);
          if (error) {
            let errorMessage = "Produto criado, mas ocorreram erros a inserir os seguintes dados: " + error + ". Por favor verifique e adicione-os manualmente";
            alert = this.UI.showAlert(errorMessage);
            alert.finally(() => {
              // Redirect to details view so it can be filled
              this.state.go('app.produto.details', {id: produto.id});
            });
          } else {
            this.state.go('app.produto.list');
          }
        }).catch(err => { // Should never happen, since resolving everything...
          console.log(err);
          localStorage.removeItem('ISR_SGI_ProdutoNewForm');
          alert = this.UI.showAlert("Produto criado, mas ocorreram erros a inserir alguns dados. Por favor verifique e adicione-os manualmente");
          alert.finally(() => {
            // Redirect to details view so it can be filled
            this.state.go('app.produto.details', {id: produto.id});
          });
        });
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao criar produto. Verifique a ligação");
        this.loaded = true;
      });
    }).catch((x) => {
      // Nothing to do. Just fix values and resubmit...
    });
  };

  // Check if there was an error adding multiple data, and return a string with the bad inserted data
  createdMultipleDataOk = (res) => {
    let output = '';
    if (res && res.length > 0) {
      res.forEach(r => {
        if (!r.ok) output += r.output + ", ";
      });
      // If there's data, remove trailing ", "
      if (output.length > 0)
        return output.slice(0, -2);
    }
    return output.length === 0 ? null : output;
  };


  isValid = () => {
    let validDefer = this.$q.defer();
    let v = true;

    // Check if produto data is well defined
    // Ano
    if (v && (isNaN(this.data.details.ano))) {
      this.UI.addToast("Ano não preenchido");
      v = false;
      validDefer.reject();
    }
    // Designação
    if (v && (!this.data.details.designacao || this.data.details.designacao.length === 0)) {
      this.UI.addToast("Designação não preenchida");
      v = false;
      validDefer.reject();
    }
    // Descrição
    if (v && (!this.data.details.descricao || this.data.details.descricao.length === 0)) {
      this.UI.addToast("Descrição não preenchida");
      v = false;
      validDefer.reject();
    }

    // Tipo de Produto
    if (v && (!this.data.auxTipo || !this.data.auxTipo.selected)) {
      this.UI.addToast("Tipo de Produto inválido");
      v = false;
      validDefer.reject();
    }
    // Open Access
    if (v && (!this.data.auxOpenAccess || !this.data.auxOpenAccess.selected)) {
      this.UI.addToast("Open Access inválido");
      v = false;
      validDefer.reject();
    }
    // Relatório Disponível
    if (v && (!this.data.auxRelatorioDisponivel || !this.data.auxRelatorioDisponivel.selected)) {
      this.UI.addToast("Relatório Disponível inválido");
      v = false;
      validDefer.reject();
    }
    // Made Available
    if (v && (!this.data.auxMadeAvailable || !this.data.auxMadeAvailable.selected)) {
      this.UI.addToast("Made Available for other researchers inválido");
      v = false;
      validDefer.reject();
    }

    // Mandatory multiple data
    if (v && (this.data.investigadores.length === 0)) {
      this.UI.addToast("Autores não preenchidos");
      v = false;
      validDefer.reject();
    }

    // Check if data is unique for multiple data
    // Investigadores
    let investigadores = this.data.investigadores.map(x => x.investigadorId);
    let investigadoresRepetidos = investigadores.filter((x, i) => investigadores.indexOf(x) !== i);
    if (v && investigadoresRepetidos.length > 0) {
      this.UI.addToast("Autores repetidos");
      v = false;
      validDefer.reject();
    }
    // Entidades Financiadoras
    let entidadesFinanciadoras = this.data.entidadesFinanciadoras.map(x => x.entidadeFinanciadoraId);
    let entidadesFinanciadorasRepetidas = entidadesFinanciadoras.filter((x, i) => entidadesFinanciadoras.indexOf(x) !== i);
    if (v && entidadesFinanciadorasRepetidas.length > 0) {
      this.UI.addToast("Entidades repetidas");
      v = false;
      validDefer.reject();
    }

    // Only validate multidata if all static data is valid, otherwise no point first
    if (v) {
      // VALIDATE ASYNC DATA
      let idData = [];

      // Add multi async data to verify
      this.data.investigadores.forEach(x => {
        idData.push({
          field: 'id',
          value: x.investigadorId,
          model: this.Investigador,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Autor inexistente"
        });
      });
      this.data.entidadesFinanciadoras.forEach(x => {
        idData.push({
          field: 'id',
          value: x.entidadeFinanciadoraId,
          model: this.EntidadeFinanciadora,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Entidade Financiadora inexistente"
        });
      });

      let wait = this.UI.showWaiting();
      // Verify all the async data
      this.ProdutoService.validateMultiData(idData).then(x => {

        // Verify impactos
        this.verifyImpactos(this.data.impacto).then(y => {
          wait.close();
          validDefer.resolve();
        }).catch(() => {
          wait.close();
          validDefer.reject();
        });

      }).catch(() => {
        wait.close();
        validDefer.reject();
      });
    }
    return validDefer.promise;
  };


  // MULTIPLE DATA CRUDs

  // Adicionar um novo investigador para produto
  addInvestigador = () => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.investigador.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.investigador = {};
          $scope.label = "Novo Autor de Produto";
          $scope.investigadores = investigadores;

          $scope.auxInvestigador = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.investigador) {
          let item = angular.copy(ok.investigador);
          item.investigadorId = ok.auxInvestigador.selected.id;
          item.investigador = angular.copy(ok.auxInvestigador.selected);

          this.data.investigadores.push(item);
        }
      });
    }).catch(error => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores para autoria. Verifique a sua ligação");
    });
  };

  // Edita informação de investigador para produto
  editInvestigador = (x) => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.investigador.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.investigador = angular.copy(x);
          $scope.label = "Editar Autor do Produto";
          $scope.investigadores = investigadores;

          $scope.auxInvestigador = {
            selected: $scope.investigador.investigador,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.investigador) {
          // Update data without replacing the variable x (so it's still an element of the array)

          x.investigadorId = ok.auxInvestigador.selected.id;
          x.investigador = angular.copy(ok.auxInvestigador.selected);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores. Verifique a sua ligação");
    });
  };

  // Remove Co-Autor com índice index
  removeInvestigador = (index) => {
    if (index < this.data.investigadores.length) {
      this.data.investigadores.splice(index, 1);
    }
  };


  // Entidades Financiadoras
  // Adicionar um nova entidade financiadora para produto
  addEntidadeFinanciadora = () => {
    let wait = this.UI.showWaiting();
    this.EntidadeFinanciadora.find({}).$promise.then((entidadesFinanciadoras) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.entidade.financiadora.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.entidadeFinanciadora = {};
          $scope.label = "Nova Entidade";
          $scope.entidadesFinanciadoras = entidadesFinanciadoras;

          $scope.auxEntidadeFinanciadora = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxEntidadeFinanciadora && ok.entidadeFinanciadora) {
          let item = angular.copy(ok.entidadeFinanciadora);
          item.entidadeFinanciadoraId = ok.auxEntidadeFinanciadora.selected.id;
          item.entidadeFinanciadora = angular.copy(ok.auxEntidadeFinanciadora.selected);

          this.data.entidadesFinanciadoras.push(item);
        }
      });
    }).catch(error => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler entidades. Verifique a sua ligação");
    });
  };

  // Edita informação de entidade financiadora para produto
  editEntidadeFinanciadora = (x) => {
    let wait = this.UI.showWaiting();
    this.EntidadeFinanciadora.find({}).$promise.then((entidadesFinanciadoras) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.entidade.financiadora.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.entidadeFinanciadora = angular.copy(x);
          $scope.label = "Editar Entidade";
          $scope.entidadesFinanciadoras = entidadesFinanciadoras;

          $scope.auxEntidadeFinanciadora = {
            selected: $scope.entidadeFinanciadora.entidadeFinanciadora,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxEntidadeFinanciadora && ok.entidadeFinanciadora) {
          // Update data without replacing the variable x (so it's still an element of the array)

          x.entidadeFinanciadoraId = ok.auxEntidadeFinanciadora.selected.id;
          x.entidadeFinanciadora = angular.copy(ok.auxEntidadeFinanciadora.selected);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler entidades. Verifique a sua ligação");
    });
  };

  // Remove Co-Autor com índice index
  removeEntidadeFinanciadora = (index) => {
    if (index < this.data.entidadesFinanciadoras.length) {
      this.data.entidadesFinanciadoras.splice(index, 1);
    }
  };

  // Impactos
  // Get data to be used in impacto edit modal
  getImpactoData = (tipo) => {
    let wait;
    let defer = this.$q.defer();
    switch(tipo) {
      case 'Ambiental':
        defer.resolve(null);
        break;
      case 'Económico':
        defer.resolve(null);
        break;
      case 'ODS':
        wait = this.UI.showWaiting();
        this.Ods.find({}).$promise.then((ods) => {
          wait.close();
          defer.resolve(ods);
        }).catch((error) => {
          wait.close();
          console.log(error);
          defer.reject(error);
        });
        break;
      case 'Social':
        defer.resolve(null);
        break;
    }
    return defer.promise;
  };

  // Edit/add impacto for tipo
  editImpacto = (tipo) => {
    this.getImpactoData(tipo).then(externalData => {
      let options = {
        size: 'lg',
        template: require('./impacto.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.tipo = tipo;
          $scope.label = "Editar Impacto " + tipo;
          $scope.impacto = angular.copy(this.data.impacto);
          switch(tipo) {
            case 'Ambiental':
              $scope.simnao = this.simnao;
              $scope.auxImpactoAmbiental = angular.copy(this.data.auxImpactoAmbiental);
              break; // Nothing to do
            case 'Económico':
              $scope.simnao = this.simnao;
              $scope.auxImpactoEconomico = angular.copy(this.data.auxImpactoEconomico);
              break;
            case 'ODS':
              $scope.externalData = externalData;
              // ODS is always "add", so it always starts as empty
              $scope.auxOds = {
                selected: undefined,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              break;
            case 'Social':
              $scope.simnao = this.simnao;
              $scope.auxImpactoSocial = angular.copy(this.data.auxImpactoSocial);
              break;
          }

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        switch(tipo) {
          case 'Ambiental':
            if(ok.auxImpactoAmbiental && ok.auxImpactoAmbiental.selected.value) { // Has "Yes" selected
              this.data.auxImpactoAmbiental = angular.copy(ok.auxImpactoAmbiental);
              this.data.impacto.ambiental = ok.impacto.ambiental;
              this.UI.addToast("Impacto ambiental atualizado");
            } else { // No ambiental data is defined, delete it
              if (this.data.impacto.ambiental) { // If it's filled, delete it, otherwise don't bother
                this.data.auxImpactoAmbiental.selected = undefined;
                delete this.data.impacto.ambiental;
                this.UI.addToast("Impacto ambiental eliminado");
              }
            }
            break;
          case 'Económico':
            if(ok.auxImpactoEconomico && ok.auxImpactoEconomico.selected.value) { // Has "Yes" selected
              this.data.auxImpactoEconomico = angular.copy(ok.auxImpactoEconomico);
              this.data.impacto.economico = ok.impacto.economico;
              this.UI.addToast("Impacto económico atualizado");
            } else { // No economico data is defined, delete it
              if (this.data.impacto.economico) { // If it's filled, delete it, otherwise don't bother
                this.data.auxImpactoEconomico.selected = undefined;
                delete this.data.impacto.economico;
                this.UI.addToast("Impacto económico eliminado");
              }
            }
            break;
          case 'ODS':
            // Check repeats - Placed here instead of isValid() so it's easier to port
            let usedOds = this.data.impacto.ods.map(x => x.odsId);
            usedOds.push(ok.auxOds.selected.id);
            let odsRepetidos = usedOds.filter((x, i) => usedOds.indexOf(x) !== i);
            if (odsRepetidos.length > 0) {
              this.UI.addToast("ODS já adicionada");
            } else { // We can add it
              this.data.impacto.ods.push({
                odsId: ok.auxOds.selected.id,
                ods: { id: ok.auxOds.selected.id, designacao: ok.auxOds.selected.designacao }
              });
              this.UI.addToast("ODS adicionado com sucesso");
            }
            break;
          case 'Social':
            if(ok.auxImpactoSocial && ok.auxImpactoSocial.selected.value) { // Has "Yes" selected
              this.data.auxImpactoSocial = angular.copy(ok.auxImpactoSocial);
              this.data.impacto.social = ok.impacto.social;
              this.UI.addToast("Impacto social atualizado");
            } else { // No social data is defined, delete it
              if (this.data.impacto.social) { // If it's filled, delete it, otherwise don't bother
                this.data.auxImpactoSocial.selected = undefined;
                delete this.data.impacto.social;
                this.UI.addToast("Impacto social eliminado");
              }
            }
            break;
        }
      });
    }).catch(error => {
      console.log(error);
      this.UI.addToast("Não foi possível ler dados para edição. Verifique a sua ligação");
    });
  };

  // Function called when changing Sim/Não
  // Clear text if it becomes Não
  togglePolicyInfluence = () => {
    if (this.data.auxImpactoPolicyInfluence) {
      if (this.data.auxImpactoPolicyInfluence.selected.value === 0) { // It was disabled, clear text
        this.data.impacto.policyInfluence = null;
      } else { // Do nothing
      }
    }
  };

  // Returns true or false if impactos data is ok to set to database
  verifyImpactos = (impacto) => {
    let defer = this.$q.defer();
    // Ambiental - Nothing to check
    // Social - Nothing to check
    // Económico - Nothing to check

    // ODS - Verifica ODSs individuais
    let deferOds = this.$q.defer();
    if (impacto.ods && impacto.ods.length > 0) {
      let odsTasks = [];
      for (let i = 0; i < impacto.ods.length; i++) {
        let o = this.$q.defer();

        this.ProdutoService.fieldValueExists('id', impacto.ods[i].id, this.Ods).then((exists) => {
          o.resolve(exists);
        }).catch(error => {
          o.reject(error);
        });
        odsTasks.push(o.promise);
      }

      this.$q.all(odsTasks).then(x => {
        deferOds.resolve(true);
      }).catch(error => {
        deferOds.reject(error);
      });
    } else {
      deferOds.resolve(true);
    }

    this.$q.all([deferOds.promise]).then(x => {
      defer.resolve();
    }).catch(error => {
      this.UI.addToast("Não foi possível verificar dados de impactos. Verifique a ligação");
      defer.reject(error);
    });

    return defer.promise;
  };

  // Save impacto data to database
  saveImpacto = (imp, object, Model) => {
    let defer = this.$q.defer();
    let newImpacto = {
      id: 0,
      ambiental: imp.ambiental || null,
      economico: imp.economico || null,
      social: imp.social || null,
      observacoes: imp.observacoes || null,
      policyInfluence: imp.policyInfluence || null,
      criadoPorId: this.user.id,
      dataCriacao: moment().format()
    };

    this.Impacto.create(newImpacto).$promise.then((impacto) => {
      defer.resolve();
      // Save impactoId to base object for reference
      object.impactoId = impacto.id;
      Model.upsert(object).$promise.then((res) => {
        // Create all ODS
        this.ProdutoService.createMultipleData(this.ImpactoOds, imp.ods, impacto.id, 'impactoId').then(x => {
          defer.resolve();
        }).catch(error => {
          console.log(error);
          defer.reject({ok: false, output: 'Impacto - ODS'});
        });
      }).catch((error) => {
        console.log(error);
        defer.reject({ok: false, output: 'Ligação a Impacto'});
      });
    }).catch((error) => {
      console.log(error);
      defer.reject({ok: false, output: 'Impacto'});
    });

    return defer.promise;
  };

  removeImpacto = (tipo, index) => {
    switch(tipo) {
      case 'Ambiental':
        this.data.auxImpactoAmbiental.selected = undefined;
        delete this.data.impacto.ambiental;
        this.UI.addToast("Impacto ambiental eliminado");
        break;
      case 'Económico':
        this.data.auxImpactoEconomico.selected = undefined;
        delete this.data.impacto.economico;
        this.UI.addToast("Impacto económico eliminado");
        break;
      case 'ODS':
        if (index < this.data.impacto.ods.length) {
          this.data.impacto.ods.splice(index, 1);
          this.UI.addToast("Objetivo eliminado");
        }
        break;
      case 'Social':
        this.data.auxImpactoSocial.selected = undefined;
        delete this.data.impacto.social;
        this.UI.addToast("Impacto social eliminado");
        break;
    }
  };

}

ProdutoCreateProdutoController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'UIService', 'ProdutoService', 'Produto', 'ProdutoInvestigador', 'ProdutoEntidadeFinanciadora', 'ProdutoTipo', 'Investigador', 'EntidadeFinanciadora', 'Pais', 'Impacto', 'ImpactoOds', 'Ods'];
